import { LogEvent } from 'src/app/interfaces/log';
import { LogService } from 'src/app/services/log/log.service';
import { ThinkingChairAnswer, ThinkingChairResult } from './../../../interfaces/thinking-chair';
import { ThinkingChairHostInputLogParams, ThinkingChairResultLogCommonParams, ThinkingChairStageLogParams } from './thinking-chair-log-params';

export class ThinkingChairLogService {
  constructor(private logService: LogService) {

  }

  private hostInputLogCommonParams: ThinkingChairHostInputLogParams | undefined;
  private resultLogCommonParams: ThinkingChairResultLogCommonParams | undefined;

  setHostInputLogCommonParams(answers: ThinkingChairAnswer[]): void {
    let tempParams: Partial<ThinkingChairHostInputLogParams> = {};
    let sum = 0;
    answers.forEach((answer, index) => {
      const { hostContent } = answer;
      const hostLength = hostContent.length;
      tempParams[`hostStage${index + 1}Length`] = hostLength;
      sum += hostLength;
    })
    tempParams.hostAllLength = sum;

    this.hostInputLogCommonParams = {
      ...tempParams as ThinkingChairHostInputLogParams
    }
  }

  setResultLogCommonParams(data: ThinkingChairResult): void {
    let tempParams: Partial<ThinkingChairResultLogCommonParams> = {};
    let hostSum = 0;
    let guestSum = 0;
    data.answers.forEach((answer, index) => {
      const { hostContent, guestContent } = answer;
      const hostLength = hostContent.length;
      const guestLength = guestContent.length;
      tempParams[`hostStage${index + 1}Length`] = hostLength;
      tempParams[`guestStage${index + 1}Length`] = guestLength;
      tempParams[`stage${index + 1}LengthDiff`] = hostLength - guestLength;
      hostSum += hostLength;
      guestSum += guestLength;
    })
    tempParams.hostAllLength = hostSum;
    tempParams.guestAllLength = guestSum;
    tempParams.allLengthDiff = hostSum - guestSum;

    this.resultLogCommonParams = {
      ...tempParams as ThinkingChairResultLogCommonParams
    }
  }
  
  // [생각 의자] 게스트 결과 - 결과 화면 진입	
  thinkingChairGuestResultIntroViewed(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_INTRO_VIEWED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 게스트 결과 - 단계별 응답 확인	
  thinkingChairGuestResultViewed(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_VIEWED, { ...this.resultLogCommonParams, ...params });
  }

  // [생각 의자] 게스트 결과 - 만족도 긍정 클릭	
  thinkingChairGuestResultSatisfiedClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_SATISFIED_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 게스트 결과 - 만족도 부정 클릭	
  thinkingChairGuestResultDissatisfiedClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_DISSATISFIED_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 게스트 결과 - 아우트로 화면 진입	
  thinkingChairGuestResultOutroViewed(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_OUTRO_VIEWED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 게스트 결과 - 친구에게 공유 버튼 클릭	
  thinkingChairGuestResultShareClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_SHARE_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 게스트 결과 - 타입스 메인으로 버튼 클릭	
  thinkingChairGuestResultGoToHomeButtonClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_RESULT_GO_TO_HOME_BUTTON_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 게스트 생성 - 글 작성 화면에서 ‘다음’ 버튼 클릭	
  thinkingChairGuestCreateQuestionnaireNextClicked(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_CREATE_QUESTIONNAIRE_NEXT_CLICKED, { ...params });
  }

  // [생각 의자] 게스트 생성 - 작성 완료	
  thinkingChairGuestCreateSubmit(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_CREATE_SUBMIT, { ...params });
  }

  // [생각 의자] 게스트 생성 - 작성 화면 진입	
  thinkingChairGuestCreateQuestionnaireViewed(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_GUEST_CREATE_QUESTIONNAIRE_VIEWED, { ...params });
  }

  // [생각 의자] 소개 화면 진입	
  thinkingChairIntroViewed({ isCreateIntro }: {isCreateIntro: boolean}): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_INTRO_VIEWED, { isCreateIntro });
  }

  // [생각 의자] 호스트 결과 - 결과 화면 진입	
  thinkingChairHostResultIntroViewed(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_INTRO_VIEWED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 호스트 결과 - 결과 화면 진입	
  thinkingChairHostResultViewed(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_VIEWED, { ...this.resultLogCommonParams, ...params });
  }

  // [생각 의자] 호스트 결과 - 만족도 긍정 클릭	
  thinkingChairHostResultSatisfiedClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_SATISFIED_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 호스트 결과 - 만족도 부정 클릭	
  thinkingChairHostResultDissatisfiedClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_DISSATISFIED_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 호스트 결과 - 아우트로 화면 진입	
  thinkingChairHostResultOutroViewed(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_OUTRO_VIEWED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 호스트 결과 - 친구에게 공유 버튼 클릭	
  thinkingChairHostResultShareClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_SHARE_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 호스트 결과 - 타입스 메인으로 버튼 클릭	
  thinkingChairHostResultGoToHomeButtonClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_RESULT_GO_TO_HOME_BUTTON_CLICKED, { ...this.resultLogCommonParams });
  }

  // [생각 의자] 호스트 생성 - 'url 복사' 버튼 클릭	
  thinkingChairHostCreateShareURLClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_SHARE_URL_CICKED, { ...this.hostInputLogCommonParams });
  }

  // [생각 의자] 호스트 생성 - '카카오톡으로 공유' 버튼 클릭	
  thinkingChairHostCreateShareWebShareClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_SHARE_WEB_API_CLICKED, { ...this.hostInputLogCommonParams });
  }

  // [생각 의자] 호스트 생성 - '카카오톡으로 공유' 버튼 클릭	
  thinkingChairHostCreateShareKakaoClicked(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_SHARE_KAKAO_CLICKED, { ...this.hostInputLogCommonParams });
  }

  // [생각 의자] 호스트 생성 - 공유 화면 진입	
  thinkingChairHostCreateShareViewed(): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_SHARE_VIEWED, { ...this.hostInputLogCommonParams });
  }

  // [생각 의자] 호스트 생성 - 글 작성 화면에서 ‘다음’ 버튼 클릭	
  thinkingChairHostCreateQuestionnaireNextClicked(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_QUESTIONNAIRE_NEXT_CLICKED, { ...params });
  }

  // [생각 의자] 호스트 생성 - 작성 완료	
  thinkingChairHostCreateSubmit(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_SUBMIT, { ...params });
  }

  // [생각 의자] 호스트 생성 - 작성 화면 진입	
  thinkingChairHostCreateQuestionnaireViewed(params: ThinkingChairStageLogParams): void {
    this.logService.eventLogging(LogEvent.THINKING_CHAIR_HOST_CREATE_QUESTIONNAIRE_VIEWED, { ...params });
  }

  // [홈] ‘생각 의자’ 버튼 노출	 
  homeThinkingChairImpression(): void {
    this.logService.eventLogging(LogEvent.HOME_THINKING_CHAIR_IMPRESSION);
  }

  // [홈] ‘생각 의자’ 버튼 클릭	
  homeThinkingChairClicked(): void {
    this.logService.eventLogging(LogEvent.HOME_THINKING_CHAIR_CLICKED);
  }
}